import { ServiceFetch } from '../service-fetch'

export default class ReceiptSaleDepositListModel extends ServiceFetch {
    getReceiptSaleReturnBy = (data) => this.authFetch({
        url: 'receipt-sale-return/getReceiptSaleReturnBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}